import heroVisual from "./images/hero-visual.png";
import React from "react";
import "./landing.scss";

function Root() {
  return (
    <div className="vl">
      <nav className="vl-nav">
        <div className="vl-brand">
          <div className="vl-logo" />
          <span className="vl-brand-text">Devite</span>
        </div>
        <div className="vl-nav-links">
          <a href="#start">Start</a>
          <a href="#technology">Technologie</a>
          <a href="#contact">Kontakt</a>
        </div>
      </nav>

      <section className="vl-hero" id="start">
        <div className="vl-container">
          <h1 className="vl-h1">
            Twoja wizja
            <br />
            <span className="vl-accent">zrealizowana w aplikacjach</span> <br />
            webowych oraz mobilnych
          </h1>
          <p className="vl-lede">
            Od lat tworzymy aplikacje webowe oraz mobilne wspierające biznes.
            Pomożemy Ci zarówno ze stworzeniem ich od zera jak i rozwojem lub
            naprawą już istniejących aplikacji.
          </p>
          <div className="vl-hero-visual">
            <img
              src={heroVisual}
              alt="Distributed system architecture visualization"
            />
          </div>
        </div>
      </section>

      <section className="vl-container vl-services" id="technology">
        {[
          {
            n: "01",
            k: "React, Next.js",
            t: "Aplikacje webowe",
            d: "Stawiamy na najpopularniejszy i najwydajniejszy duet do tworzenia aplikacji webowych. Dzięki Reactowi budujemy interfejsy, w których użytkownicy lubią spędzać czas, a Next.js pozwala nam tworzyć szybkie aplikacje z doskonałym pozycjonowaniem w Google",
          },
          {
            n: "02",
            k: "React Native",
            t: "Aplikacje mobilne",
            d: "Jedna aplikacja, dwa systemy, maksymalna wydajność. Tworzymy szybkie i niezawodne aplikacje mobilne na iOS oraz Android w tym samym czasie. Pozwala to zmniejszyć koszty utrzymania, ułatwia rozwój oraz wprowadzanie aktualizacji.",
          },
        ].map((s) => (
          <div className="vl-service" key={s.n}>
            <span className="vl-service-kicker">{s.k}</span>
            <h3>{s.t}</h3>
            <p>{s.d}</p>
          </div>
        ))}
      </section>

      <footer className="vl-footer" id="contact">
        <div className="vl-container vl-footer-row">
          <div>
            <div className="vl-ready">Skontaktuj się z nami</div>
            <div className="vl-contact">kontakt@devite.pl</div>
            <div className="vl-copy">Copyright &copy; 2026 DEVITE </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
export default Root;
